
document.addEventListener('DOMContentLoaded', function() {

  
    staggerText();
    var slickEl = {};
    var homeCarousel = $('#hero-banner').slick({
        
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite : true,
        loop:false,
        dots : false,    
        arrows : false,
        autoplay: true,
        
        speed: 1000,
        fade: true,
        cssEase: 'linear',
        pauseOnHover: false
    });

    homeCarousel.on('afterChange', function(event, slick, currentSlide){


        if (slick.$slides.length - 1 == currentSlide) {
            slickEl = slick
            slick.slickPause();
            $('.replay').addClass('show')
         }
    });

    $('.replay').on('click', function(){
        slickEl.slickGoTo(0)
        slickEl.slickPlay();
        $(this).removeClass('show')
    })

    $('#testimonial-carousel').slick({
        
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite : false,
        prevArrow: $('.testimonial-carousel .prev'),
        nextArrow: $('.testimonial-carousel .next'),
    });

    $('#carousel-videos').slick({
        
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite : false,
        prevArrow: $('.videos-carousel .prev'),
        nextArrow: $('.videos-carousel .next'),
    });


    

    $('#team-carousel').slick({
        
        slidesToShow: 2,
        slidesToScroll: 1,
        infinite : false,
        prevArrow: $('.team-carousel .prev'),
        nextArrow: $('.team-carousel .next'),
    });




    $('#green-carousel').slick({
        
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite : false,
        autoplay: true,
        dots: true,
        arrows: false,
        customPaging : function(slider, i) {
            return '<span class="custom-dot"></span>';
        },

       
    });

    $('#overlfow-carousel').slick({
        
        slidesToShow: 2.25,
        slidesToScroll: 1,
        infinite : false,
        autoplay: false,
        dots: true,
        arrows: false,
        customPaging : function(slider, i) {
            return '<span class="custom-dot"></span>';
        },

       
    });


    $('#awards-carousel').slick({
        
        slidesToShow: 4,
        slidesToScroll: 1,
        infinite : false,
        autoplay: false,
        dots: false,
        arrows: true,
        prevArrow: $('.awards-carousel .prev'),
        nextArrow: $('.awards-carousel .next'),

       
    });

    $('#carousel-location').slick({
        
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite : false,
        autoplay: false,
        dots: false,
        arrows: true,
        prevArrow: $('.carousel-location .prev'),
        nextArrow: $('.carousel-location .next'),

       
    });


    


})

//if($(window).width() > 767){
    $(window).on("scroll load", function(){
        requestAnimationFrame( scrollFade );

     
    })
//}



function scrollFade(){
  

    var _window = jQuery(window);
    var d = _window

    jQuery(".scroll-fade").each(function(){
        var c = jQuery(this),
        e = (c.offset().top + c.outerHeight(), d.scrollTop() + d.height());
        c.offset().top <= e - .1 * d.height() ? c.addClass("in-view") : c.offset().top > e - .1 * d.height(); //&& c.removeClass("in-view") 
      })
               

}

function staggerText() {

    

    $('.hero-text').each(function(){

       var words = $(this).text().split(' ');
       
       (function(words, _this){
         console.log("words", words)  
            if(!words.length)
            {
                return
            }
            var line = '';
            var delay = 0.3;
            var increment = 0.02317558299;
            words.map(function(word){
                        
                        var letter = ''
                       
                        word.split('').forEach(function(c) {

                            delay += increment
                            letter += `<span style="animation-delay:${delay}s" class="intro-text">${c}</span>`;
                            

                        });
                        line += `<span class="intro-word">${letter}&nbsp;</span>`
                        
            });
            _this.html(line)
            

       })(words, $(this))
       

    })
}


//header sticky

// Hide Header on on scroll down
var didScroll;
var lastScrollTop = 0;
var delta = 5;
var navbarHeight = $('.header').outerHeight();

$(window).scroll(function(event){
    didScroll = true;
});

setInterval(function() {
    if (didScroll) {
        hasScrolled();
        didScroll = false;
    }
}, 250);

function hasScrolled() {
    var st = $(this).scrollTop();
    
    // Make sure they scroll more than delta
    if(Math.abs(lastScrollTop - st) <= delta)
        return;
    
    // If they scrolled down and are past the navbar, add class .nav-up.
    // This is necessary so you never see what is "behind" the navbar.
    if (st > lastScrollTop && st > navbarHeight){
        // Scroll Down
        $('.header').removeClass('nav-down').addClass('nav-up');
    } else {
        // Scroll Up
        if(st + $(window).height() < $(document).height()) {
            $('.header').removeClass('nav-up').addClass('nav-down');
        }
    }
    
    lastScrollTop = st;
}